require('./mentions-legales.scss');

export default function MentionsLegalesComponent() {
  return {
    controller: MentionsLegalesController,
    controllerAs: 'ctrl',
    template: require('./mentions-legales.html')
  };
}

function MentionsLegalesController() {
  let ctrl = this;
  ctrl.domain = window.location.hostname;
  window.scroll(0, 0);
}



// WEBPACK FOOTER //
// ./src/modules/base/components/mentions-legales/mentions-legales.component.js